<template>
  <c-sidesheet :active="localActive" @close="close">
    <div class="modal-frame">
      <div class="modal-wrapper">
        <shadow-scroll-container ref="track" class="modal-track" :with-top-scroller="true">
          <div class="modal-padding">
            <div v-if="!hideHeader" class="modal-frame__header">
              <h2 class="modal-frame__title">
                <slot name="title">
                  {{ title }}
                </slot>
              </h2>

              <div class="modal-frame__actions">
                <slot name="header-actions"></slot>
              </div>
            </div>
            <slot></slot>
          </div>
        </shadow-scroll-container>
      </div>
      <div v-if="!hideFooter" class="modal-actions">
        <slot name="actions"></slot>
      </div>
    </div>
  </c-sidesheet>
</template>

<script>
import CSidesheet from "@/components/sidesheet";
import ShadowScrollContainer from "@/components/shadow-scroll-container";

export default {
  components: {
    CSidesheet,
    ShadowScrollContainer,
  },
  props: ["active", "title", "hideHeader", "hideFooter"],
  data() {
    return {
      localActive: false,
    };
  },
  watch: {
    active(v) {
      this.localActive = v;
    },
  },
  methods: {
    close() {
      this.localActive = false;
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";
@import "~@/assets/styles/grid.scss";

/deep/ {
  .sidesheet {
    &__header {
      display: none;
    }
    &__wrapper {
      padding: 0 !important;
      z-index: 1001;
    }

    &__content {
      height: 100%;
      padding: 0;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    &__close {
      padding-right: 10px;
      padding-top: 10px;
    }
  }
}

.modal-frame {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  &__header {
    margin-bottom: 22px;
  }

  &__title {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 0;
  }

  &__actions {
    display: flex;
    align-items: center;

    &:not(:empty) {
      margin-top: 12px;
      margin-bottom: 12px;
    }
  }

  @include bootstrapMd {
    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    &__title {
      font-size: 22px;
    }
    &__actions {
      &:not(:empty) {
        margin-top: 0;
        margin-bottom: 0;
      }
    }
  }
}

.modal-wrapper {
  flex-grow: 1;
  display: flex;
  overflow: hidden;
}

.modal-track {
  width: 100%;
  height: 100%;

  /deep/ {
    .scroll-container {
      padding-right: 0;
    }
  }
}

.modal-padding {
  padding: 0 20px 20px;
  @include onlyMobile {
    padding-top: 35px;
  }
}

.modal-actions {
  flex-shrink: 0;
  background: white;
  display: flex;
}

@include beforeBootstrapMd {
  .modal-actions {
    border-top: 1px solid #d3d8df;
    /deep/ {
      button {
        flex-basis: 100%;
        width: 100%;
        border-radius: 0;
        flex-shrink: 1;
      }
    }
  }
}

@include bootstrapMd {
  .modal-padding {
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 40px;
    padding-top: 25px;
  }

  .modal-actions {
    align-items: center;
    justify-content: flex-end;
    padding: 10px 30px;
    box-shadow: 0px 0px 15px rgba(0, 21, 80, 0.3);

    /deep/ {
      button {
        margin-left: 10px;
      }
    }
  }
}
</style>
